import React from "react";

import { ObservabilityPipelineHttpMetricsOverview } from "Api/observability/pipeline/types";

import ImpactTable from "./ImpactTable";

const TopImpact = ({
  httpMetricsOverview
}: {
  httpMetricsOverview:
    | ObservabilityPipelineHttpMetricsOverview
    | null
    | undefined;
}) => {
  return <ImpactTable httpMetricsOverview={httpMetricsOverview} />;
};

export default TopImpact;
